export abstract class InstitutionManagementRoutes {
    static Users = 'users';
    static Information = 'information';
    static Pending = 'pending';
}
